import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  SimpleChange,
  SimpleChanges,
} from "@angular/core";
import * as moment from "moment";
import { ToastrService } from "ngx-toastr";
import { UtilityService } from "src/app/shared/services/Utils/utility.service";

@Component({
  selector: "app-date-filter",
  templateUrl: "./date-filter.component.html",
  styleUrls: ["./date-filter.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DateFilterComponent implements OnInit {
  from: any;
  to: any;
  isInvalidDate: boolean = false;
  @Input() isClear: Boolean = false;
  @Output("fromDateValue") fromDateValueEmitter = new EventEmitter();
  @Output("toDateValue") toDateValueEmitter = new EventEmitter();

  constructor(
    private utilityService: UtilityService,
    private toastr: ToastrService
  ) {}

  ngOnChanges(changes: SimpleChanges) {
    const isClearChange: SimpleChange = changes.isClear; // @Input() isClear
    if (isClearChange.previousValue !== undefined) {
      if (isClearChange.currentValue !== isClearChange.previousValue) {
        // this.getMainCategories()
        if (this.from || this.to) {
          return this.clearFilters();
        }
      }
    }
  }

  ngOnInit(): void {}

  // async startDate(event) {
  //   this.from = event;
  //   this.isInvalidDate = false;
  //   if (this.to) {
  //     let fromDateCheck = await this.timeValidation(this.from, 'from')
  //     if (!fromDateCheck && !this.isInvalidDate) {
  //       this.fromDateValueEmitter.emit(this.to)
  //       this.fromDateValueEmitter.emit(this.from) // ***condition added on Nov 18***
  //     }
  //   }
  //   else {
  //     this.fromDateValueEmitter.emit(this.from)
  //   }
  // }

  // async endDate(event) {
  //   this.to = event;
  //   if (this.from) {
  //     let toDateCheck = await this.timeValidation(this.to, 'to')
  //     if (!toDateCheck && !this.isInvalidDate) {
  //       this.toDateValueEmitter.emit(this.to)
  //       this.toDateValueEmitter.emit(this.to) // ***condition added on Nov 18***
  //     }
  //   }
  //   else {
  //     this.toDateValueEmitter.emit(this.to)
  //   }
  // }
  async startDate(event) {
    this.from = event;
    this.fromDateValueEmitter.emit(this.from);
    this.to = moment().format("yyyy-MM-DD");
    this.toDateValueEmitter.emit(this.to);
  }

  async endDate(event) {
    this.to = event;
    this.toDateValueEmitter.emit(this.to);
    this.fromDateValueEmitter.emit(this.from);
  }
  clearFilters(value?) {
    this.from = "";
    this.to = "";
  }

  timeValidation(event, value) {
    return new Promise(async (resolve, reject) => {
      let fromDate = value == "from" ? new Date(event) : new Date(this.from);
      let toDate = value == "to" ? new Date(event) : new Date(this.to);
      let date = moment(toDate);
      if (moment(fromDate).subtract(1, "days").isBefore(date)) {
        this.isInvalidDate = false;
        resolve(this.isInvalidDate);
      } else {
        this.isInvalidDate = true;
        this.toastr.error(
          "From date cannot be greater than to date, Please select valid date"
        );
        this.from = "";
        resolve(this.isInvalidDate);
      }
    });
  }
}
